// Radar-ping animation layered on the LOCKED FieldRadar artwork (no redraw).
// A teal ping travels along the existing thick sweep; rings expand and fade behind it.
const GEO = {
  mark:   { src: "/brand/fr-mark.png?v=10",   w: 1760, h: 1406, cx: 959, cy: 947, r: 857, a0: -175, a1: -55 },
  lockup: { src: "/brand/fr-lockup.png?v=10", w: 4137, h: 1242, cx: 842, cy: 827, r: 738, a0: -176, a1: -54 },
};
const TEAL = "#14B8A6";
const pt = (g, deg) => {
  const t = (deg * Math.PI) / 180;
  return [g.cx + g.r * Math.cos(t), g.cy + g.r * Math.sin(t)];
};

export function AnimatedLogo({ variant = "lockup", height = 88, dur = 3.2, className = "" }) {
  const g = GEO[variant] || GEO.lockup;
  const [x0, y0] = pt(g, g.a0);
  const [x1, y1] = pt(g, g.a1);
  const path = `M ${x0.toFixed(1)} ${y0.toFixed(1)} A ${g.r} ${g.r} 0 0 1 ${x1.toFixed(1)} ${y1.toFixed(1)}`;
  const ring = g.r * 0.05;
  const width = (height * g.w) / g.h;
  return (
    <svg viewBox={`0 0 ${g.w} ${g.h}`} width={width} height={height} className={className}
         role="img" aria-label="FieldRadar.pro" data-testid={`fr-animated-${variant}`} style={{ overflow: "visible" }}>
      <defs>
        <filter id="frGlow" x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur stdDeviation={ring * 0.6} result="b"/>
          <feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id="frCore">
          <stop offset="0%" stopColor="#ffffff"/>
          <stop offset="45%" stopColor={TEAL}/>
          <stop offset="100%" stopColor={TEAL} stopOpacity="0"/>
        </radialGradient>
      </defs>
      <image href={g.src} x="0" y="0" width={g.w} height={g.h}/>
      {/* faint sweep trail that brightens as the ping passes */}
      <path d={path} fill="none" stroke="#ffffff" strokeWidth={ring * 1.1} strokeLinecap="round" opacity="0.35"
            strokeDasharray={`${g.r * 0.35} ${g.r * 4}`} style={{ mixBlendMode: "screen" }}>
        <animate attributeName="stroke-dashoffset" from={g.r * 0.35} to={-g.r * 2.2} dur={`${dur}s`} repeatCount="indefinite"/>
      </path>
      {/* ping head + expanding rings */}
      <g>
        <animateMotion dur={`${dur}s`} repeatCount="indefinite" path={path} keyPoints="0;1" keyTimes="0;1" calcMode="linear"/>
        {[0, 0.45, 0.9].map((delay, i) => (
          <circle key={i} r={ring} fill="none" stroke={TEAL} strokeWidth={ring * 0.22} opacity="0">
            <animate attributeName="r" from={ring} to={ring * 11} dur="1.8s" begin={`${delay}s`} repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0.9;0" dur="1.8s" begin={`${delay}s`} repeatCount="indefinite"/>
          </circle>
        ))}
        <circle r={ring * 1.6} fill="url(#frCore)" filter="url(#frGlow)"/>
      </g>
    </svg>
  );
}
